<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-12" type="text" label="Наименование позиции"
        v-model.trim="equipment.name" placeholder="Введите название"
        :disabled="!permissionsStatus.isZoneUpdateAllowed"/>
      <ccs-input class="ccs-6" type="dropdown" label="Наличие"
        v-if="isEditing" v-model="equipment.status"
        :items="equipmentStatuses" placeholder="Выберите статус"
        :disabled="!permissionsStatus.isZoneStatusAllowed" :modifiers="['no_cancel']"/>
      <ccs-input class="ccs-6" type="autocomplete" label="Спонсор"
        v-if="isEditing" v-model="equipment.sponsor_id" :items="sponsorsForSelect"
        @change="onSponsorSearch" placeholder="Начните ввод для поиска"
        :disabled="!permissionsStatus.isZoneSponsorAllowed"/>
      <ccs-input class="ccs-6" type="text" label="Единицы измерения"
        v-model.trim="equipment.unit" placeholder="Введите ед. измерения"
        :disabled="!permissionsStatus.isZoneUpdateAllowed"/>
      <ccs-input class="ccs-6" type="number" label="Количество на участника"
        v-model.number="equipment.count" placeholder="Введите кол-во"
        :disabled="!permissionsStatus.isZoneUpdateAllowed"/>
      <ccs-input class="ccs-4" type="number" label="Количество, всего"
        v-model.number="equipment.total_count" placeholder="Введите кол-во"
        :disabled="!permissionsStatus.isZoneUpdateAllowed"/>
      <ccs-input class="ccs-8" type="text" label="Примерная стоимость, всего" imgAlt="руб"
        v-model.number="equipment.price" placeholder="Введите стоимость"
        :disabled="!permissionsStatus.isZoneUpdateAllowed"/>
    </div>
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-12" type="textarea" label="Описание"
        v-model.trim="equipment.description" placeholder="Введите описание"
        :disabled="!permissionsStatus.isZoneUpdateAllowed"/>
      <ccs-input class="ccs-12" type="textarea" label="Комментарий"
        v-model.trim="equipment.comment" placeholder="Введите комментарий"
        :disabled="!permissionsStatus.isZoneUpdateAllowed"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Equipment',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      equipment: {
        name: '',
        description: '',
        unit: '',
        count: 0,
        total_count: 0,
        price: 0,
        comment: '',
        sponsor_id: null,
        status: null,
      },
      sponsorsForSelect: [],
      equipmentStatuses: [{
        prop: null,
        text: 'Неизвестно',
      }, {
        prop: 'union',
        text: 'СОЮЗ',
      }, {
        prop: 'organizer',
        text: 'Организатор',
      }],
    };
  },
  props: {
    zone_id: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    ...mapGetters('session', ['permissionsStatus']),
    isEditing() {
      return this.equipment.id && this.equipment.id !== 0;
    },
  },
  methods: {
    ...mapActions('skills', ['createEquipment', 'updateEquipment']),
    async onSponsorSearch(text) {
      [this.sponsorsForSelect] = await this.getAutocompleteData('/v1/sponsors/list', text);
    },
    async submit() {
      if (this.equipment.id) {
        await this.edit();
      } else {
        await this.add();
      }
    },
    async add() {
      try {
        this.equipment.zone_id = this.zone_id;
        let equipment = await this.createEquipment(this.equipment);
        this.$toasted.success('Оборудование добавлено');
        this.$emit('submit', equipment);
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async edit() {
      try {
        await this.updateEquipment(this.equipment);
        this.$toasted.success('Изменения сохранены');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  created() {
    if (this.$props.data && this.$props.data.id) {
      this.equipment = Object.assign({}, this.$props.data);
      if (this.$props.data.sponsor.id) {
        this.equipment.sponsor_id = this.$props.data.sponsor.id;
        this.sponsorsForSelect = [{
          prop: this.$props.data.sponsor.id,
          searchText: this.$props.data.sponsor.name,
        }];
      }
    }
  },
}
</script>

<style>

</style>